export { default as NavLink } from './NavLink';



// WEBPACK FOOTER //
// ./src/components/Footer/NavLink/index.ts